import { useSiteMaterial } from 'features';
import { useTranslation } from 'i18n';
import { Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, CardsListSkeleton, Grid, Page, Section } from 'ui';

import { SampleListSelect } from '../../components/SampleListSelect/SampleListSelect';
import { SiteHeader } from '../../components/SiteHeader/SiteHeader';

export const SamplesEdit = () => {
  const { t } = useTranslation('orders');
  const navigate = useNavigate();
  const { data: siteMaterial } = useSiteMaterial();

  return (
    <Page>
      <Page.Title title={t('samplesEditPage.pageTitle')} />
      <Page.Divider />
      <Grid container>
        <Grid
          size={{
            md: 4,
            xs: 12,
          }}
        >
          <Section title={t('samplesEditPage.sections.siteDetails')}>
            <SiteHeader siteMaterial={siteMaterial} />
          </Section>
        </Grid>
        <Grid
          size={{
            md: 8,
            xs: 12,
          }}
        >
          <Section
            title={t('samplesEditPage.sections.sampleDetails')}
            action={
              <Button size="large" fullWidth variant="secondary" onClick={() => navigate(-1)}>
                {t('samplesEditPage.actions.cancel')}
              </Button>
            }
          >
            <Suspense fallback={<CardsListSkeleton />}>
              <SampleListSelect siteMaterialId={siteMaterial.public_id} onClose={() => navigate(-1)} />
            </Suspense>
          </Section>
        </Grid>
      </Grid>
    </Page>
  );
};
